import type { TMessages } from '@/types/TMessages'

export const messages = {
  required: '* Обязательное поле',
  agreement: `Нажатие на кнопку "Отправить" подтверждает ваше согласие на передачу данных, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в <Highlighted>ООО МКК "Поле Инвест</Highlighted>`,
} satisfies TMessages
